import { ChangeEvent, MutableRefObject } from 'react';

interface IInputProps {
  name: string;
  className?: string;
  value: string;
  handleChange: (e: ChangeEvent<HTMLInputElement>, index?: number) => void;
  handleClick?: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
  placeholder?: string;
  isInvalid?: boolean;
}

export const InputControlled = ({
  name,
  className = '',
  placeholder = 'Type here...',
  value,
  handleChange,
  handleClick = () => {},
  onFocus = () => {},
  onBlur = () => {},
  isInvalid = false,
}: IInputProps) => (
  <input
    type="text"
    name={name}
    value={value}
    onChange={handleChange}
    placeholder={placeholder}
    className={`${className} text-gray-400 bg-gray-800 px-4 py-[10px] rounded ${isInvalid ? 'outline outline-1 outline-error-700' : ''}`}
    onClick={handleClick}
    onFocus={onFocus}
    onBlur={onBlur}
  />
);
